function formatMoney(cents, format = "") {
  if (typeof cents === "string") {
    cents = cents.replace(".", "");
  }
  const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/, formatString = format || window.themeVariables.settings.moneyFormat;
  function defaultTo(value2, defaultValue) {
    return value2 == null || value2 !== value2 ? defaultValue : value2;
  }
  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultTo(precision, 2);
    thousands = defaultTo(thousands, ",");
    decimal = defaultTo(decimal, ".");
    if (isNaN(number) || number == null) {
      return 0;
    }
    number = (number / 100).toFixed(precision);
    let parts = number.split("."), dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands), centsAmount = parts[1] ? decimal + parts[1] : "";
    return dollarsAmount + centsAmount;
  }
  let value = "";
  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_space_separator":
      value = formatWithDelimiters(cents, 2, " ", ".");
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 2, "'", ".");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
    case "amount_no_decimals_with_space_separator":
      value = formatWithDelimiters(cents, 0, " ");
      break;
    case "amount_no_decimals_with_apostrophe_separator":
      value = formatWithDelimiters(cents, 0, "'");
      break;
    default:
      value = formatWithDelimiters(cents, 2);
      break;
  }
  if (formatString.indexOf("with_comma_separator") !== -1) {
    return formatString.replace(placeholderRegex, value);
  } else {
    return formatString.replace(placeholderRegex, value);
  }
}
var currencyFormat = window.themeVariables.settings.currencyCodeEnabled ? window.themeVariables.settings.moneyWithCurrencyFormat : window.themeVariables.settings.moneyFormat;


$(document).ready(function() {  
  $( ".size_chart-toggle" ).click(function(e) {
      e.preventDefault();
      $('.size-pop_main').fadeIn();
    });
    $( ".size-popup_close" ).click(function() {
      $('.size-pop_main').fadeOut();
    });
  
    $("body").on('keypress','#personalize_initial', function (event) {    
      var regex = new RegExp("^[a-zA-Z0-9-,.@]+$");
      var key = String.fromCharCode(!event.charCode ? event.which : event.charCode);
      if (!regex.test(key)) {
         event.preventDefault();
         return false;
      }    
    });
  
    $('body').on('click','.best_buy .copy_code .code', function(){
      $('.copied').remove();
      var temp = $("<input>");
      $("body").append(temp);
      temp.val($(this).attr('data-code')).select();
      document.execCommand("copy");
      temp.remove();
      $(this).closest('.copy_code').after('<span class="copied" style="font-size: 14px; font-weight: 500; color: #742222;">Code Copied!!!</span>');
      setTimeout(function(){
        $('.copied').remove();
      }, 3000);
    });
    
    $("body").on('keyup','#personalize_initial', function (event) {
      if($(this).val().length > 0){
        $(this).attr('name','properties[Initials]');
      }else{
        $(this).removeAttr('name');
      }
    });
    
    $("body").on('change','#add-on-product-mono-gram', function (event) {  
      var cur_val = parseInt($('.product_button-price').attr('price'));
      var sale_single_price = parseInt($(this).attr('sale_single_price'));
      if($(this).is(':checked')){
        $(this).closest('.personalize_assembly').find('.personalize_main_content').slideDown(); 
        
        $('.product_button-price').attr('price',cur_val + sale_single_price);
        $('.product_button-price').html(formatMoney(cur_val + sale_single_price, currencyFormat));
  
        $('.sticy_button-price').attr('price',cur_val + sale_single_price);
        $('.sticy_button-price').html(formatMoney(cur_val + sale_single_price, currencyFormat));
      }else{            
        $(this).closest('.personalize_assembly').find('.personalize_main_content').slideUp();  
        $(this).closest('.personalize_assembly').find('#personalize_initial').val('').trigger('keyup');
        
        $('.product_button-price').attr('price',cur_val - sale_single_price);
        $('.product_button-price').html(formatMoney(cur_val - sale_single_price, currencyFormat));
  
        $('.sticy_button-price').attr('price',cur_val - sale_single_price);
        $('.sticy_button-price').html(formatMoney(cur_val - sale_single_price, currencyFormat));
      }
      
    });
  
  $('body').on('click', '.add-on_product-button_add-remove', function() {
    var campare_single_price = parseInt($(this).attr('campare_single_price'));
    var sale_single_price = parseInt($(this).attr('sale_single_price'));
    var add_remove_button = $(this).parents('.ao-product_item').find('.add-on_product-button');
    var remove_button = $(this).parents('.ao-product_item').find('.ao-product_item-remove')
    $(add_remove_button).toggleClass('active');
    $(remove_button).toggleClass('active');
    if($(add_remove_button).hasClass("add-on_product-button")){
      $(add_remove_button).text($(add_remove_button).text() == 'Add' ? 'Added' : 'Add');
    }
    // $('.product-form__submit').toggleClass('combine');
    var cur_val = parseInt($('.product_button-price').attr('price'));
    if($(this).hasClass('active')){
      $('.product_button-price').attr('price',cur_val + sale_single_price);
      $('.product_button-price').html(formatMoney(cur_val + sale_single_price, currencyFormat));
  
      $('.sticy_button-price').attr('price',cur_val + sale_single_price);
      $('.sticy_button-price').html(formatMoney(cur_val + sale_single_price, currencyFormat));
    }else{
      $('.product_button-price').attr('price',cur_val - sale_single_price);
      $('.product_button-price').html(formatMoney(cur_val - sale_single_price, currencyFormat));
  
      $('.sticy_button-price').attr('price',cur_val - sale_single_price);
      $('.sticy_button-price').html(formatMoney(cur_val - sale_single_price, currencyFormat));
    }
  });

  $('.ts_wrap').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    mobileFirst: true,
    arrows: false,
    dots: true,
    responsive: [
      {
        breakpoint: 700,
        settings: 'unslick'
      }
    ]
  });

  $(window).on('resize', function() {
    $('.ts_wrap').slick('resize');
  });
  
  $('.testimonial-custom_main').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: true,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 699,
        settings: {
          arrows: false
        }
      }
    ]
  });

  $('.testi-sec-blocks').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 1000,
    dots: true,
    responsive: [
      {
        breakpoint: 999,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 699,
        settings: {
          slidesToShow: 1,
        }
      }
    ]
  });

  $('body').on('click', '.facets-topbar-item__title', function(e) {
   var id = $(this).attr('id_for');
   if ($(this).hasClass('active')) {
     $('.facets-topbar-item__title').removeClass('active');
     $('.facets-topbar-item__content').hide();
     $('.facets-topbar-item__title').attr("aria-expanded","false");
     $(this).removeClass('active');
     $(`#${id}`).hide();
     $(this).attr("aria-expanded","false");
   } else {
     $('.facets-topbar-item__title').removeClass('active');
     $('.facets-topbar-item__content').hide();
     $('.facets-topbar-item__title').attr("aria-expanded","false");
     $(this).addClass('active');
     $(`#${id}`).show();
     $(this).attr("aria-expanded","true");
   }
  });

  $(".header__dropdown-menu-mega_link").mouseenter(function(){
    var id = $(this).attr('data-id'); 
     $('.header__dropdown-menu-mega_link').removeClass('active');
     $(this).addClass('active');
  
      $('.header__dropdown-submenu-mega_main').hide();
      $(`#${id}`).show();
  });

  $('.testi-items_wrap').masonry({
    itemSelector: '.testi-item',
    columnWidth: '.grid-sizer'
  });


  (function () {
    function initCompareSlick(modal) {
      var $slick = $(modal).find('.js-compare-leather-slick');
      if (!$slick.length) return;

      // Focus the currently-selected swatch
      var initialIndex = $slick.find('[data-compare-swatch].is-selected').closest('.compare-leather__slide').index();
      if (initialIndex < 0) initialIndex = 0;

      if ($slick.hasClass('slick-initialized')) {
        $slick.slick('unslick');
      }

      $slick.slick({
        slidesToShow: 7,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        initialSlide: initialIndex,
        swipeToSlide: true,
        responsive: [
          { breakpoint: 700, settings: { slidesToShow: 5 } }
        ]
      });
    }

    document.addEventListener('toggle', function (e) {
      var modal = e.target;
      if (modal.matches && modal.matches('x-modal') && modal.hasAttribute('open')) {
        // wait a frame so the modal is visible & measurable
        requestAnimationFrame(function () { initCompareSlick(modal); });
      }
    }, true);
  })();

  $(document).on('click', '[data-compare-swatch]', function () {
    var $btn  = $(this);
    var value = $btn.data('compare-value');
    var $root = $btn.closest('.modal-compare-leather-inner');

    $root.find('[data-compare-swatch]').removeClass('is-selected');
    $root.find('[data-compare-swatch][data-compare-value="' + value + '"]').addClass('is-selected');

    $root.find('.modal-compare-leather__hero-image').removeClass('is-active')
        .filter('[data-compare-hero-for="' + value + '"]').addClass('is-active');

    $root.find('.modal-compare-leather__content').removeClass('is-active')
        .filter('[data-compare-content-for="' + value + '"]').addClass('is-active');
  });

});

// $(function() {
//   const $section = $('#lockScrollSection');
//   const $media1 = $('.bag-detail_media-1');
//   const $media2 = $('.bag-detail_media-2');
//   const $media3 = $('.bag-detail_media-3');
//   const $media4 = $('.bag-detail_media-4');

//   const startOffset = $section.offset().top;
//   const endOffset = startOffset + $section.outerHeight();

//   $(window).on('scroll', function () {
//     const scrollTop = $(this).scrollTop();
    
//     if (scrollTop >= startOffset && scrollTop <= endOffset) {
//       const progress = (scrollTop - startOffset) / ($section.height());

//       // Move each media layer upward slightly more than the last
//       $media2.css('transform', `translateY(${-5 - progress * 100}%)`);
//       $media3.css('transform', `translateY(${-10 - progress * 150}%)`);
//       $media4.css('transform', `translateY(${-20 - progress * 200}%)`);
//     }
//   });
// });

if($('#lockScrollSection').length > 0){
  
  $(function () {
    const $section = $('#lockScrollSection');
    const $media2 = $('.bag-detail_media-2');
    const $media3 = $('.bag-detail_media-3');
    const $media4 = $('.bag-detail_media-4');
  
    const $info1 = $('.bag-detail_info_1');
    const $info2 = $('.bag-detail_info_2');
    const $info3 = $('.bag-detail_info_3');
  
    $(window).on('scroll', function () {
      const scrollTop = $(this).scrollTop();
      const windowHeight = $(this).height();
  
      const startOffset = $section.offset().top - windowHeight / 2;
      const sectionHeight = $section.outerHeight();
      const endOffset = startOffset + sectionHeight;
  
      if (scrollTop >= startOffset && scrollTop <= endOffset) {
        const progress = (scrollTop - startOffset) / sectionHeight;
  
        // Move bag pieces
        $media2.css('transform', `translateY(${-5 - progress * 50}%)`);
        $media3.css('transform', `translateY(${-10 - progress * 75}%)`);
        $media4.css('transform', `translateY(${-20 - progress * 100}%)`);
  
        // Info block activation
        $info1.removeClass('active');
        $info2.removeClass('active');
        $info3.removeClass('active');
  
        if(window.matchMedia('(max-width: 740px)').matches){
          if (progress < 0.50) { $info1.addClass('active'); } 
          else if (progress > 0.51 && progress < 0.85) { $info2.addClass('active'); } 
          else { $info3.addClass('active'); }
        }else{
          if (progress < 0.49) { $info1.addClass('active'); } 
          else if (progress > 0.50 && progress < 0.65) { $info2.addClass('active'); } 
          else { $info3.addClass('active'); }
        }
        
      } else if (scrollTop < startOffset) {
        // Reset above section
        $media2.css('transform', `translateY(-5%)`);
        $media3.css('transform', `translateY(-10%)`);
        $media4.css('transform', `translateY(-20%)`);
  
        $info1.addClass('active');
        $info2.removeClass('active');
        $info3.removeClass('active');
      }
    });
  });
}







$(document).ready(function () {
  function isInViewport(element) {
      var rect = element[0].getBoundingClientRect();
      return rect.top < window.innerHeight && rect.bottom > 0;
  }

  // $(window).on("scroll", function () {
  //   $(".bag-detail_media").each(function (index) {
  //     if (isInViewport($('.bag-detail_info_1'))) { // Check if individual item is visible
  //       var scrollTop = $(window).scrollTop();
  //       var sectionTop = $(this).offset().top;
  //       var windowHeight = $(window).height();
  //       var default_position = parseInt($(this).attr("default-position")) || 0; // Fallback to 0

  //       var progress = (scrollTop + windowHeight - sectionTop) / windowHeight;
  //       var translateY = default_position - Math.min(progress * 75, 75); // Limit max translation

  //       // Ensure translateY does not go below default_position
  //       // translateY = Math.max(translateY, default_position);
  //       if(translateY < default_position){
  //         $(this).attr('style',`transform: translateY(${translateY * (index * 0.25)}%);`);
  //       }
  //     }
  //   });
  // });


  // --------------------------
  // const section_main = document.getElementById('bag-detail_list');
  
  // const section_1 = document.getElementById('bag-detail_list-item_1');
  // const section_2 = document.getElementById('bag-detail_list-item_2');
  // const section_3 = document.getElementById('bag-detail_list-item_3');

  // window.addEventListener('scroll', () => {
  //   const rect_main = section_main.getBoundingClientRect();
    
  //   const rect_1 = section_1.getBoundingClientRect();
  //   const rect_2 = section_2.getBoundingClientRect();
  //   const rect_3 = section_3.getBoundingClientRect();
    

  //   // When the section touches (or passes) the top
  //   if (rect_main.top <= 0 && rect_main.bottom > 0) {
  //     section_main.classList.add('touched');
  //   } else {
  //     section_main.classList.remove('touched');
  //   }
    
  //   if (rect_1.top <= 0 && rect_1.bottom > 0) {
  //     section_1.classList.add('at-top');
  //   } else {
  //     section_1.classList.remove('at-top');
  //   }
    
  //   if (rect_2.top <= 0 && rect_2.bottom > 0) {
  //     section_2.classList.add('active');
  //   } else {
  //     section_2.classList.remove('active');
  //   }

  //   if (rect_3.top <= 0 && rect_3.bottom > 0) {
  //      section_2.classList.remove('active');
  //     section_3.classList.add('active');
  //   } else {
  //     section_3.classList.remove('active');
  //   }

  //   if((rect_2.top <= 0 && rect_2.bottom > 0) || (rect_3.top <= 0 && rect_3.bottom > 0)){
  //     $('.bag-detail_list-item_1').removeClass('active')
  //   }else{
  //     $('.bag-detail_list-item_1').addClass('active')
  //   }
  // });

  $('.image_slideshow-wrapper').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: true
  });

  $('.collections--tabs_content-item--product-list').slick({
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 5000,
    pauseOnHover: false,
    cssEase: 'linear',
    responsive: [
    {
      breakpoint: 699,
      settings: {
        arrows: false,
        slidesToShow: 1,
        speed: 6000
      }
    }
    ]
  });
  $('.collections--tabs_header-item').click(function(){
    $('.collections--tabs_header-item ').removeClass('active');
    $(this).addClass('active');
    $('.collections--tabs_content-item').hide();
    
    var activeTab = $(this).attr('href');
    $(activeTab).show();

    $('.collections--tabs_content-item--product-list').slick('unslick');
    $('.collections--tabs_content-item--product-list').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: true,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    pauseOnHover: false,
    cssEase: 'linear',
    responsive: [
    {
      breakpoint: 699,
      settings: {
        arrows: false,
        slidesToShow: 1,
      }
    }
    ]
  });
    return false;
  });

  $('.achievement-slider').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    infinite: false,
    arrows: true,
    dots: true,
    responsive: [
      {
        breakpoint: 749,
        settings: {
          arrows: false
        }
      }
    ]
  });

  // OPPORTUNITIES TAB -------
  $('document').ready(function(){
    if(location.href.includes('#')){
      var opportunities_hash_1 = location.href.split('career-page')[1].split('#')[1];
      var opportunities_hash_2 = location.href.split('career-page')[1].split('#')[2];
      console.log('00000',opportunities_hash_1,opportunities_hash_2);

      setTimeout(function() { 
        $(`.btnn-tab[href="#${opportunities_hash_1}"]`).click();
        $(`.sub-btnn-tab[href="#${opportunities_hash_2}"]`).click();
      }, 1000);
    }else{    
      $('.click-1').click();
      $('.sub-btnn-tab.btn-1-1').click();
    }
  }) 
  
  $('body').on('click','.btnn-tab', function(){
    $(this).addClass('active').parent('.opportunities_btn_tabs').siblings().find('.btnn-tab').removeClass('active');
    var tabBtn = $(this).attr('data-btn');
    console.log('tabBtn',tabBtn);
    $(this).closest('.header-wrp').find('.sub-btnn-tabs-list').map(function(){
      var subBtn = $(this).attr('data-subbtn')      
      console.log('subBtn',subBtn);
      if(tabBtn == subBtn){
        $(this).show();
      }else{
        $(this).hide();
      }
    });
    $('.sub-btnn-tabs-list').each(function(){
      var subtabBtn = $(this).attr('data-subbtn');
      if (tabBtn == subtabBtn) {
        console.log('subtabBtn',subtabBtn);
        $(this).find('button:first').trigger("click");
      }
    });
  })
  $('body').on('click','.sub-btnn-tab', function(){
    $(this).addClass('active').siblings().removeClass('active');
    var subBTn = $(this).attr('data-con');
    console.log('subBtn',subBTn);
    $(this).closest('.opportunities-sec-inr').find('.opportunities_content_list').map(function(){
      $(this).find('.opportunities_content_wrp-inr').map(function(){
        var showText = $(this).attr('data-text');
        console.log('showText',showText);
        if(subBTn == showText){
          $(this).show();
        }else{
          $(this).hide();
        }
      })
    })
  })
      
  $('body').on('click','.ctryModal-Content .stay_here_button', function(){
    $(".ctryModal-Content-overlay").removeClass('active');
    $(".ctryModal-Content").removeClass('active');
    $("body").removeClass('overflow-hidden');
  });

  $('body').on('click', '.leather-type-tab', function () {
    $(this).closest('.leather-type-tabs').find('.leather-type-tab').removeClass('active');
    $(this).addClass('active');
    const leather_type_tab = $(this).attr('data-tab');
    $('.leather-type-block-item').removeClass('active').addClass('hidden');
    $('.leather-type-block-item[data-item="' + leather_type_tab + '"]').addClass('active').removeClass('hidden');
  });
  $('body').on('click','.leather-type-block-inner', function() {
    const popup_name = $(this).attr('data-popoup');
    $(this).closest('.leather-type-inner').find('.leather-type-block-modal').each(function () {
      const modal_name = $(this).attr('data-modal');
      console.log('popup_name',popup_name);
      console.log('modal_name',modal_name);
      if (popup_name == modal_name) {
        $(this).addClass('active');
      }
    })
  })

  $('body').on('click','.leather-type-block-modal-overlay, .leather-type-block-modal__close-button', function() {
    $(this).closest('.leather-type-block-modal').removeClass('active');
  })

});

function complementary_addon(){
  $.getJSON("/cart.js", function (cart) {
    console.log('cart',cart);
    const allComplementary = cart.items.every(item => 
      item.properties && item.properties._type === "complementary_addon"
    );

    if (allComplementary) {
      const updates = {};
      cart.items.forEach((item) => {
        if (item.properties && item.properties._type === "complementary_addon") {
          updates[item.key] = 0; // Use item.key to target the item safely
        }
      });

      if (Object.keys(updates).length > 0) {
        $.ajax({
          type: 'POST',
          url: '/cart/update.js',
          data: {
            updates: updates
          },
          dataType: 'json',
          async: false,
          success: function(data) {
            console.log("🗑️ Complementary items removed using keys.");
            if (document.body.classList.contains("template-cart")) {
              location.reload();
            }else{
              document.dispatchEvent(new CustomEvent("cart:refresh"));
            }
          },
          error: function(jqXHR) {
            console.error("❌ Error while removing items:", jqXHR);
          }
        });
      } else {
        console.log("ℹ️ No complementary_addon items found to remove.");
      }
    } else {
      console.log("❌ Not all items are complementary_addon");
    }
  });
}
document.addEventListener("cart:change", () => {
  complementary_addon();
});
window.onload = function() {
  if (document.body.classList.contains('template-cart')) {
    complementary_addon();
  }
}


$('.similer-products-navigation-button').click(function(){
  $('.similer-products-navigation-button').removeClass('active');
  $('.similer-products-carousel__item').hide();
  $(this).addClass('active');
  
  var activeTab = $(this).attr('data-attr');
  $(activeTab).fadeIn();
  return false;
});

document.addEventListener("variant:change", function (event) {
  let variant = event.detail.variant;
  let form = event.target;
  var product_handle = $("body").attr("product-handle");
  console.log('event',event);
  $.get(`/products/${product_handle}?variant=${variant.id}`, function (data) {
    $("#similer-color_products")?.html(
      $(data).find("#similer-color_products").html()
    );
  });
});

(function ($) {
  'use strict';
 
  if (typeof $ === 'undefined') return;
 
  /* ---------- Custom text animation ---------- */
 
  // Scale the single-line headline to fill ~92% of the viewport width,
  // re-run whenever the rotating word changes length (mimics "big text").
  function fitTitle($root) {
    var $title = $root.find('.banner-hero__title');
    if (!$title.length) return;
    var target = $root.width() * 0.92;
    $title.css('font-size', '100px');
    var scale = target / $title[0].scrollWidth;
    $title.css('font-size', Math.min(100 * scale, 220) + 'px');
  }
 
  // function refitAll() {
  //   $('[data-banner-hero]').each(function () {
  //     fitTitle($(this));
  //   });
  // }
 
  // Swap the rotating word; driven by Slick's beforeChange so it moves with the fade.
  function swapWord($root) {
    var words = $root.data('bhWords');
    if (!words || words.length < 2) return;
 
    var $word = $root.find('.banner-hero__word');
    var i = ($root.data('bhWordIndex') || 0);
 
    $word.removeClass('is-entering').addClass('is-leaving'); // drop down + fade out
    setTimeout(function () {
      i = (i + 1) % words.length;
      $root.data('bhWordIndex', i);
      $word.text(words[i]);
      // fitTitle($root);
      $word.removeClass('is-leaving').addClass('is-entering'); // drop in from above
    }, 400); // matches the bh-word-out animation
  }
 
  /* ---------- Init ---------- */
 
  $(document).ready(function () {
    $('[data-banner-hero]').each(function () {
      var $root = $(this);
 
      var words = [];
      try { words = JSON.parse($root.attr('data-words') || '[]'); } catch (e) {}
      words = $.map(words, function (w) { return $.trim(w) || null; });
      $root.data('bhWords', words).data('bhWordIndex', 0);
 
      // Fade the headline in + size it to the width
      // fitTitle($root);
      requestAnimationFrame(function () { $root.addClass('is-ready'); });
 
      // ---- Slick slideshow (minimal init) ----
      var $slides = $root.find('.banner-hero__slides');
      if (typeof $slides.slick !== 'function') return;
      if ($slides.find('.banner-hero__slide').length < 2) return;
 
      var slideTime = parseInt($root.attr('data-slide-time'), 10) || 6000;
 
      // Bind before init so the first transition is caught
      $slides.on('beforeChange', function () { swapWord($root); });
 
      $slides.slick({
        fade: true,
        arrows: false,
        dots: false,
        autoplay: true,
        autoplaySpeed: slideTime,
        speed: 1200,
        pauseOnHover: false
      });
    });
 
    // $(window).on('resize.bannerHero', refitAll);
  });
})(window.jQuery);